var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKyiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 21.5L11 16L6.50003 20L2.50003 18.5L3.50003 14.5L10.5 14.5L2.00003 12L2.00003 8L5.50003 7L10.5 13L8.00003 5L11.5 2L15 5L12.5 13L17.5 7L21 8L21 12L12.5 14.5L19.5 14.5L20.5 18.5L16.5 20L12 16L12.5 21.5L11.5 21.5L10.5 21.5Z",
    fill: "#032436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKyiv);
export default __webpack_public_path__ + "static/media/icon-kyiv.1db3fed9fb0bcd834654bc936bdb39e3.svg";
export { ForwardRef as ReactComponent };